import React from 'react';
import './StaticPages.css';

const TermsOfUse = () => {
  return (
    <div className="static-page">
      <h1>Pravila korišćenja</h1>
      <div className="content">
        <section>
          <h2>Dobrodošli na Jaka kao Majka blog</h2>
          <p>
            Molimo vas da pažljivo pročitate pravila korišćenja pre upotrebe našeg sajta. Korišćenjem ovog sajta prihvatate ova pravila u potpunosti.
          </p>
        </section>

        <section>
          <h2>Autorska prava</h2>
          <p>
            Svi tekstovi, fotografije i ostali sadržaji objavljeni na ovom blogu zaštićeni su autorskim pravima i ne smeju se kopirati, reprodukovati niti distribuirati bez prethodne pisane dozvole autora. Neovlašćeno korišćenje sadržaja biće smatrano kršenjem Zakona o autorskim pravima.
          </p>
        </section>

        <section>
          <h2>Komentari i interakcija</h2>
          <p>
            Ohrabrujemo konstruktivnu diskusiju i deljenje iskustava. Međutim, zadržavamo pravo da uklonimo neprikladne komentare koji sadrže:
          </p>
          <ul>
            <li>1. Uvredljiv ili neprimeren sadržaj</li>
            <li>2. Spam ili reklamni sadržaj</li>
            <li>3. Lažne informacije</li>
            <li>4. Sadržaj koji krši autorska prava</li>
          </ul>
        </section>

        <section>
          <h2>Medicinske informacije</h2>
          <p>
            Sadržaj na ovom blogu je informativnog karaktera i ne zamenjuje stručni medicinski savet. Uvek se konsultujte sa svojim lekarom pre donošenja bilo kakvih zdravstvenih odluka.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUse; 